import React, { createContext, useContext } from "react";
import { config as defaultConfig } from "@/config";

/**
 * Contexto de configuración del widget
 * Permite pasar configuraciones como apiKey desde el componente padre
 */
const ConfigContext = createContext(null);

/**
 * Hook para acceder a la configuración del widget
 * @returns {Object} Objeto con la configuración (apiKey, apiUrl, etc.)
 */
export const useConfig = () => {
    const context = useContext(ConfigContext);
    if (!context) {
        throw new Error("useConfig debe usarse dentro de ConfigProvider");
    }
    return context;
};

/**
 * Provider de configuración para el widget
 * @param {Object} props
 * @param {string} props.apiKey - API key para autenticación (REQUERIDO)
 * @param {React.ReactNode} props.children - Componentes hijos
 */
export const ConfigProvider = ({ apiKey, children }) => {
    // Validar que apiKey es proporcionado
    if (!apiKey) {
        throw new Error(
            '❌ AMB-IA Chat Widget: La propiedad "apiKey" es requerida.\n\n' +
            '📝 Uso correcto:\n' +
            '   <ChatWidget apiKey="tu-api-key-aqui" />\n\n' +
            '🔑 Para obtener una API key, contacta al equipo de One System SAS.\n' +
            '   URL: https://apps.bcgs-amb.com\n'
        );
    }

    const configValue = {
        apiKey: apiKey,
        apiUrl: defaultConfig.apiUrl,
        appName: defaultConfig.appName,
        env: defaultConfig.env,
    };

    return (
        <ConfigContext.Provider value={configValue}>
            {children}
        </ConfigContext.Provider>
    );
};
